export default __webpack_public_path__ + "47ffb8195f2d8f2b80ae3c912f04baeb.png";